module.exports = __webpack_public_path__ + "img/ic_wallet.ee0f14ff.png";